import { useState } from "react";
import { useTranslation } from "react-i18next";
import { XMarkIcon } from "@heroicons/react/24/outline";

export const HseEventFilters = ({ filters, onFilterChange, onClose }) => {
  const { t } = useTranslation();
  const [localFilters, setLocalFilters] = useState(filters);

  const eventTypes = [
    { value: "injury", label: t("Skade") },
    { value: "near_miss", label: t("Nærhendelse") },
    { value: "property_damage", label: t("Materiellskade") },
    { value: "environmental", label: t("Miljøhendelse") },
    { value: "other", label: t("Annet") },
  ];

  const statusOptions = [
    { value: "draft", label: t("Kladd") },
    { value: "submitted", label: t("Innsendt") },
    { value: "under_review", label: t("Under vurdering") },
    { value: "closed", label: t("Lukket") },
  ];

  const handleFilterChange = (key, value) => {
    const newFilters = { ...localFilters, [key]: value };
    setLocalFilters(newFilters);
  };

  const handleApplyFilters = () => {
    onFilterChange(localFilters);
    onClose();
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      search: "",
      event_type: "",
      status: "",
      start_date: "",
      end_date: "",
    };
    setLocalFilters(clearedFilters);
    onFilterChange(clearedFilters);
  };

  return (
    <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mt-4">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-sm font-medium text-gray-900">{t("Filtre")}</h4>
        <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("Hendelsestype")}
          </label>
          <select
            value={localFilters.event_type}
            onChange={(e) => handleFilterChange("event_type", e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >
            <option value="">{t("Alle typer")}</option>
            {eventTypes.map((type) => (
              <option key={type.value} value={type.value}>
                {type.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("Status")}
          </label>
          <select
            value={localFilters.status}
            onChange={(e) => handleFilterChange("status", e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          >
            <option value="">{t("Alle statuser")}</option>
            {statusOptions.map((status) => (
              <option key={status.value} value={status.value}>
                {status.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("Fra dato")}
          </label>
          <input
            type="date"
            value={localFilters.start_date}
            onChange={(e) => handleFilterChange("start_date", e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t("Til dato")}
          </label>
          <input
            type="date"
            value={localFilters.end_date}
            onChange={(e) => handleFilterChange("end_date", e.target.value)}
            className="w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
      </div>

      <div className="flex justify-end space-x-3 mt-4">
        <button
          onClick={handleClearFilters}
          className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          {t("Nullstill")}
        </button>
        <button
          onClick={handleApplyFilters}
          className="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          {t("Bruk filtre")}
        </button>
      </div>
    </div>
  );
};
